import React from 'react';
import propTypes from 'prop-types';
import { Stack, Typography } from '@metarouter-private/mr-mui';

function PipelineClusterCell({ pipelineName, clusterName }) {
  return (
    <Stack>
      <Typography variant="body2" component="div" fontWeight="500">
        {pipelineName}
      </Typography>
      <Typography variant="caption" component="div" color="secondary">
        {clusterName}
      </Typography>
    </Stack>
  );
}

PipelineClusterCell.propTypes = {
  pipelineName: propTypes.string.isRequired,
  clusterName: propTypes.string.isRequired,
};

export default PipelineClusterCell;
